import { render, staticRenderFns } from "./vFormTEXT.vue?vue&type=template&id=2d47dc5c&scoped=true&"
import script from "./vFormTEXT.vue?vue&type=script&lang=js&"
export * from "./vFormTEXT.vue?vue&type=script&lang=js&"
import style0 from "./vFormTEXT.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./vFormTEXT.vue?vue&type=style&index=1&id=2d47dc5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d47dc5c",
  null
  
)

export default component.exports